/** Dev-only logging — stripped from production builds by Vite. */
export function devLog(...args: unknown[]): void {
	if (import.meta.env.DEV) {
		console.debug(...args);
	}
}
